import React,{useEffect,useState} from 'react';
import './App.css';


import Home from './pages/Home';
import Other from './pages/Other';
import ContactUs from './pages/ContactUs';
import Error from './pages/Error';
import Coperate from './pages/Coperate';
import ArticlePage from './pages/ArticlePage';
import Navbar from './components/Navbar';
import Head from "./components/Head";
import Footer from './components/Footer';
import Article from './pages/Article';
import HomeArticle from './pages/HomeArticle';
import Aboutus from './pages/Aboutus';
import Write from './pages/Writeforus';
import Sliderarticles from './pages/Postsliderpage';
 import firebase from './firebase/Firebase';
import GotoTop from './components/GotoTop';
import SocialMediaPopup from './components/SocialMediaPopup';

import Change from './pages/Change';

import {Switch, Route} from 'react-router-dom';

function App() {

 
  return (
    <>
    <SocialMediaPopup />
    <Head/>
    
      
      <Navbar />
      
    
     <Switch>


          <Route exact path ="/article/:id" component={Article}/>
          <Route exact path="/" component={Home} />
       <Route exact path="/about-us" component={Aboutus} />

       <Route exact path="/other" component={Other} />
       <Route exact path="/article/:category/:id" component={HomeArticle} />
       <Route exact path="/article-slider/:category/:id" component={Sliderarticles} />

       <Route exact path="/contact-us" component={ContactUs} />
       <Route exact path="/write-for-us" component={Write} />



       <Route exact path="/article-page" component={ArticlePage} />
       <Route exact path="/:category" component={Coperate} />

       <Route component={Error} /> 
       






      
     </Switch>
     <Footer />
     
     <GotoTop />
            
            
           

       {/* <Route exact path="/" component={Change} />  */}
          
            
    </>
  );
}

export default App;
